import { render, staticRenderFns } from "./ESG.vue?vue&type=template&id=a789cbc6"
import script from "./ESG.vue?vue&type=script&lang=js"
export * from "./ESG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports